import * as tslib_1 from "tslib";
import { IgrFormatSpecifier } from "./igr-format-specifier";
import { NumberFormatSpecifier as NumberFormatSpecifier_internal } from "./NumberFormatSpecifier";
import { ensureBool } from "./componentUtil";
var IgrNumberFormatSpecifier = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrNumberFormatSpecifier, _super);
    function IgrNumberFormatSpecifier() {
        return _super.call(this) || this;
    }
    IgrNumberFormatSpecifier.prototype.createImplementation = function () {
        return new NumberFormatSpecifier_internal();
    };
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "locale", {
        get: function () {
            return this.i.l;
        },
        set: function (v) {
            this.i.l = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "compactDisplay", {
        get: function () {
            return this.i.h;
        },
        set: function (v) {
            this.i.h = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "currency", {
        get: function () {
            return this.i.i;
        },
        set: function (v) {
            this.i.i = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "currencyDisplay", {
        get: function () {
            return this.i.j;
        },
        set: function (v) {
            this.i.j = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "currencySign", {
        get: function () {
            return this.i.k;
        },
        set: function (v) {
            this.i.k = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "localeMatcher", {
        get: function () {
            return this.i.m;
        },
        set: function (v) {
            this.i.m = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "notation", {
        get: function () {
            return this.i.n;
        },
        set: function (v) {
            this.i.n = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "numberingSystem", {
        get: function () {
            return this.i.o;
        },
        set: function (v) {
            this.i.o = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "signDisplay", {
        get: function () {
            return this.i.p;
        },
        set: function (v) {
            this.i.p = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "style", {
        get: function () {
            return this.i.q;
        },
        set: function (v) {
            this.i.q = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "unit", {
        get: function () {
            return this.i.r;
        },
        set: function (v) {
            this.i.r = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "unitDisplay", {
        get: function () {
            return this.i.s;
        },
        set: function (v) {
            this.i.s = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "useGrouping", {
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "minimumIntegerDigits", {
        get: function () {
            return this.i.f;
        },
        set: function (v) {
            this.i.f = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "minimumFractionDigits", {
        get: function () {
            return this.i.e;
        },
        set: function (v) {
            this.i.e = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "maximumFractionDigits", {
        get: function () {
            return this.i.c;
        },
        set: function (v) {
            this.i.c = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "minimumSignificantDigits", {
        get: function () {
            return this.i.g;
        },
        set: function (v) {
            this.i.g = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrNumberFormatSpecifier.prototype, "maximumSignificantDigits", {
        get: function () {
            return this.i.d;
        },
        set: function (v) {
            this.i.d = +v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrNumberFormatSpecifier;
}(IgrFormatSpecifier));
export { IgrNumberFormatSpecifier };
//# sourceMappingURL=igr-number-format-specifier.js.map
